import {ChangeEvent} from "react";
import {RegisterOptions, useFormContext} from "react-hook-form";

import {Checkbox} from "@/components/checkbox/Checkbox.tsx";
import {FormSubtext} from "@/components/formSubtext/FormSubtext.tsx";
import {getFormError} from "@/lib/form/form.utils.ts";
import {FieldProps} from "@/pages/checks/components/form/fields/common.ts";

interface CheckBoxFieldProps extends FieldProps {
  onChange?: (value: boolean) => void;
}

export const CheckBoxField = ({
  name,
  label,
  className,
  tooltip,
  supportLink,
  helpText,
  required,
  disabled = false,
  onChange,
}: CheckBoxFieldProps) => {
  const {
    register,
    formState: {errors},
  } = useFormContext();
  const fieldError = getFormError(name, errors);
  const extraOptions: RegisterOptions = {
    ...(onChange && {onChange: ({target}: ChangeEvent<HTMLInputElement>) => onChange(target.checked)}),
  };
  if (required) {
    extraOptions["required"] = "This field is required";
  }
  return (
    <div className={className}>
      <Checkbox>
        <Checkbox.Input id={name} {...register(name, extraOptions)} disabled={disabled} />
        <Checkbox.Label forId={name} helpText={tooltip} disabled={disabled}>
          {label}
        </Checkbox.Label>
      </Checkbox>
      <FormSubtext subText={helpText} supportLink={supportLink} error={fieldError?.toString()} />
    </div>
  );
};
